import { useState } from "react";
import styled from "styled-components";
import bannerSrc from "../../assets/images/banner-blog.jpeg";
import { Footer } from "../../components/Footer";
import { Header } from "../../components/Header";
import { MainBanner } from "../../components/MainBanner";
import { usePageTrack } from "../../hooks/useAnalyticsPageTracker";
import { Response, Search, useBlogs } from "../../hooks/useBlogs";
import { Container } from "../../theme/styles";
import { Form } from "./components/Form";
import { Results } from "./components/Results";
import { Submit } from "./helpers/submit";

function Theses() {
  usePageTrack();

  const [results, setResult] = useState<Response|null>(null);
  const [search, setSearch] = useState<Search|null>(null);
  const [page, setPage] = useState<number>(1);
  const firstData: Response = useBlogs();

  async function submit(_search: Search|null, _page: number = 0) {
    if(!_search) _search = search;
    if(!_page) _page = page;
    const result = await Submit(_search, _page);
    setResult(result);
    setSearch(_search);
    setPage(_page)
  }

  return (
    <>
      <Header />
      <MainBanner bannerSrc={bannerSrc} />
      <Content>
        <Form 
          submit={submit}
        />
        <Results 
          results={results?.results || firstData.results} 
          pagination={results?.pagination || firstData?.pagination} 
          submit={submit}
        />
      </Content>
      <Footer />
    </>
  );
}

export default Theses;

const Content = styled(Container)`
  padding: 32px 14px 64px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    padding: 0 14px;
  }

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    flex-direction: column-reverse;
  }
`;